// 配置路由文件

import { HomeOutlined, AppstoreOutlined, TeamOutlined, GlobalOutlined, BarChartOutlined } from '@ant-design/icons';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // 产品列表界面开始*****************************************
  {
    title: '硬件预览/全部开发板/产品product_line一级产品列表页',
    route: '/product',
    icon: <AppstoreOutlined />,
    para: 'type',
  },
  // 参数为product_category二级产品列表页，参数/后面可以加入cpu_family表示三级产品列表页
  {
    title: '产品列表-imx',
    route: '/product-imx',
    icon: <AppstoreOutlined />,
    para: 'product_category',
  },
  {
    title: '产品列表-imx-rt',
    route: '/product-imx-rt',
    icon: <AppstoreOutlined />,
    para: 'product_category',
  },
  {
    title: '产品列表-layerscape',
    route: '/product-layerscape',
    icon: <AppstoreOutlined />,
    para: 'product_category',
  },
  {
    title: '产品列表-mcx',
    route: '/product-mcx',
    icon: <AppstoreOutlined />,
    para: 'product_category',
  },
  {
    title: '产品列表-partner-forlinx',
    route: '/product-partner-forlinx',
    icon: <AppstoreOutlined />,
    para: 'product_category',
  },
  {
    title: '产品列表-partner-wpig',
    route: '/product-partner-wpig',
    icon: <AppstoreOutlined />,
    para: 'product_category',
  },
  {
    title: '产品列表-smart-car',
    route: '/product-smart-car',
    icon: <AppstoreOutlined />,
    para: 'product_category',
  },
  // 产品列表界面结束*****************************************

  {
    title: '产品详情',
    route: '/details',
    icon: <HomeOutlined />,
    para: 'name',
  },
  {
    title: '我的预约',
    route: '/my',
    icon: <TeamOutlined />,
  },
  {
    title: '登录',
    route: '/login',
    icon: <TeamOutlined />,
    hidden: true,
  },
  {
    title: '开发中',
    route: '/developing',
    icon: <TeamOutlined />,
    hidden: true,
  },
  {
    title: '404',
    route: '/no_found',
    icon: <TeamOutlined />,
    hidden: true,
  },
  {
    title: '技术支持',
    route: '/support',
    icon: <TeamOutlined />,
    hidden: true,
  },
  {
    title: '政策条款',
    route: '/privacy',
    icon: <TeamOutlined />,
    hidden: true,
    para: 'id',
  },
  {
    title: '首页',
    route: '/index',
    icon: <TeamOutlined />,
    hidden: true,
  },
  {
    title: '软件',
    route: '/software',
    icon: <TeamOutlined />,
    hidden: true,
  },

  {
    title: '应用范例首页',
    route: '/use-case',
    icon: <AppstoreOutlined />,
  },
  {
    title: '应用范例详情',
    route: '/use-case-show',
    icon: <AppstoreOutlined />,
    para: 'id',
  },
  {
    title: '系统方案首页',
    route: '/solution',
    icon: <AppstoreOutlined />,
  },
  {
    title: '系统方案详情',
    route: '/solution-show',
    icon: <AppstoreOutlined />,
    para: 'id',
  },
  {
    title: '关于我们',
    route: '/about-us',
    icon: <TeamOutlined />,
    // hidden: true,
  },
  {
    title: '学习园地',
    route: '/learning-resources',
    icon: <TeamOutlined />,
    // hidden: true,
  },
  {
    title: '全国大学生智能汽车竞赛视觉组专区',
    route: '/smartcar-vision',
    icon: <TeamOutlined />,
    // hidden: true,
  },
]